export default "__VITE_ASSET__CUjiVhRl__"